import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Define the type for the context value
type URLContextType = string;

// Create the context with a default empty string
const URLContext = createContext<URLContextType>("");

// Define the props type for the provider
interface URLProviderProps {
  children: ReactNode;
}

export const URLProvider: React.FC<URLProviderProps> = ({ children }) => {
  const location = useLocation();
  const [currentURL, setCurrentURL] = useState<string>(location.pathname);

  useEffect(() => {
    setCurrentURL(location.pathname);
  }, [location]);

  return <URLContext.Provider value={currentURL}>{children}</URLContext.Provider>;
};

// Custom hook to use the URL context
export const useURL = (): URLContextType => useContext(URLContext);
